interface SecuritySectionProps {
  onResetPassword: () => void;
}

export default function SecuritySection({
  onResetPassword,
}: SecuritySectionProps) {
  return (
    <section className="rounded-lg border border-background-200/70 bg-background-50 p-5">
      <h2 className="font-heading text-lg font-bold text-foreground-950">
        Seguridad
      </h2>
      <p className="mt-1 text-sm text-foreground-600">
        Para cambiar tu contraseña te enviamos un enlace seguro a tu correo.
        Nunca guardamos tu contraseña.
      </p>
      <div className="mt-5 space-y-3">
        <button
          type="button"
          onClick={onResetPassword}
          className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-200 bg-background-50 px-4 py-2.5 text-sm font-semibold text-foreground-700 transition-colors hover:bg-background-100"
        >
          <i className="ri-lock-line"></i>
          Cambiar contraseña
        </button>
        <div className="flex items-start gap-3 rounded-md border border-background-200 bg-background-100/50 p-4">
          <i className="ri-information-line text-foreground-500"></i>
          <p className="text-sm text-foreground-600">
            Recibirás un correo con un enlace seguro para crear una nueva
            contraseña. El enlace expira por tu seguridad.
          </p>
        </div>
      </div>
    </section>
  );
}